// extracted by mini-css-extract-plugin
module.exports = {"otpSpinner":"uK61G","spinnerWrap":"_291O8","inputOtp":"_3j5AA","otpScreen":"_2QGxj"};